"use strict";

exports.__esModule = true;
var _PlantTwinRoutes = require("./PlantTwinRoutes");
Object.keys(_PlantTwinRoutes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PlantTwinRoutes[key]) return;
  exports[key] = _PlantTwinRoutes[key];
});